import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly sentryErrorHandler = Sentry.createErrorHandler({
    showDialog: false,
  });

  handleError(error: Error): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    this.sentryErrorHandler.handleError(error);

    if (chunkFailedMessage.test(error.message)) {
      const { href } = window.location;
      window.location.href = href;
    }
  }
}
